import { MODAL_CONFIGS } from "../constants";
import { OperationFlags } from "../types/expenseDraft";
import { LabeledValue } from "antd/es/select";

export const getFlag = (
  id: string | LabeledValue | undefined,
  prefix: string
) => {
  if (typeof id === "string") {
    return id.startsWith(prefix);
  } else {
    (id?.value as string)?.startsWith(prefix);
  }
  return false;
};

export const extractItemName = (id: string, prefix: string) =>
  id.replace(prefix, "");

export const getModalConfig = (flags: OperationFlags) => {
  const {
    isNewDescription,
    isNewSupplier,
    isReactivateDescription,
    isReactivateSupplier,
  } = flags;

  if (isNewDescription && isNewSupplier) {
    return MODAL_CONFIGS.NEW_DESCRIPTION_AND_SUPPLIER;
  }
  if (isNewDescription && isReactivateSupplier) {
    return MODAL_CONFIGS.NEW_DESCRIPTION_AND_REACTIVATE_SUPPLIER;
  }
  if (isReactivateDescription && isNewSupplier) {
    return MODAL_CONFIGS.REACTIVATE_DESCRIPTION_AND_NEW_SUPPLIER;
  }
  if (isReactivateDescription && isReactivateSupplier) {
    return MODAL_CONFIGS.REACTIVATE_DESCRIPTION_AND_SUPPLIER;
  }
  if (isNewDescription) {
    return MODAL_CONFIGS.NEW_DESCRIPTION;
  }
  if (isReactivateDescription) {
    return MODAL_CONFIGS.REACTIVATE_DESCRIPTION;
  }
  if (isNewSupplier) {
    return MODAL_CONFIGS.NEW_SUPPLIER;
  }
  if (isReactivateSupplier) {
    return MODAL_CONFIGS.REACTIVATE_SUPPLIER;
  }

  return;
};
